import { useCallback, useEffect, useMemo, useState } from "react";

const useBudgetRequestCallCenter = () => {
  const [budgetMotivo, setBudgetMotivo] = useState(0)
  const [budgetObservacao, setBudgetObservacao] = useState("")
  const [budgetMotivoError, setBudgetMotivoError] = useState(true)
  const [budgetObservacaoError, setBudgetObservacaoError] = useState(true)

  const [budgetMidia, setBudgetMidia] = useState(0);
  const [budgetMidiaError, setBudgetMidiaError] = useState(true);

  const [budgetRequestValido, setBudgetRequestValido] = useState(false)

  useEffect(() => {
      if(!budgetMotivo) setBudgetMotivoError(true);
      if(!budgetMidia)setBudgetMidiaError(true);
      if(!budgetObservacao) setBudgetObservacaoError(false);

      if(budgetMotivoError || budgetMidiaError) setBudgetRequestValido(false); 
      else setBudgetRequestValido(true);
  }, [budgetMotivo, budgetObservacao, budgetMidia])

  const changeBudgetRequestForm = useCallback(async(name, value) => {
    switch (name) {
      case "budgetMotivo":
        return setBudgetMotivo(value);
      case "budgetObservacao":
        return setBudgetObservacao(value);
      case "budgetMidia":
        return setBudgetMidia(value);
      case "budgetMotivoError":
        return setBudgetMotivoError(value);
      case "budgetObservacaoError":
        return setBudgetObservacaoError(value);
      case "budgetMidiaError":
        return setBudgetMidiaError(value);
      default:
        return null;
    }
  }, []);

  return useMemo(
    () => ({
      budgetRequest: {
        budgetMotivo,
        budgetObservacao,
        budgetMidia,
        budgetMotivoError,
        budgetObservacaoError,
        budgetMidiaError,
        budgetRequestValido,
      },
      changeBudgetRequestForm,
    }),
    [
        budgetMotivo,
        budgetObservacao,
        budgetMidia,
        budgetMotivoError,
        budgetObservacaoError,
        budgetMidiaError,
        budgetRequestValido,
    ]
  );
};

export default useBudgetRequestCallCenter;
